@if (isSupported) {
    <ms-share-my-bet [placedBetInfo]="placedBetInfo" [expandable]="true" />
    <ms-share-my-bet-copy [betslipId]="slip.betNumber" [location]="trackingInformation" [withHeader]="false" />
}
